import React from "react";

import ItemListCard from "./ItemListCard";

const ItemListItems = ({ items }) =>
  items.map((item) => <ItemListCard key={item.title} {...item} />);

export default ItemListItems;
